/* eslint-disable */
import { REHYDRATE } from 'redux-persist';
import { CREATE_USER_PROFILE, UPDATE_USER_PROFILE } from './UserProfile.types';

/**
 * Create the state for the `userProfileReducer` before `redux-persist` kicks in
 * @param {Entry} entry The entry that is currently being used
 * @returns {State} The initial state before `redux-persist` kicks in
 */
const createUserProfilePersistState = ({ displayName }) => ({
  displayName,
});

/**
 * Create the state for the `userProfileReducer` before `redux-persist` kicks in
 * @param {state} state The state
 * @returns {any} The initial state before `redux-persist` kicks in
 */
const userProfileReducer = ({ entry }) => (state = createUserProfilePersistState(entry), action) => {
  switch (action.type) {
    case REHYDRATE: {
      if (!action.payload) {
        return state
      }
      const { ...newState } = action.payload;
      return newState;
    }
    case CREATE_USER_PROFILE: {
      const { ...newState } = action.payload;
      return newState;
    }
    case UPDATE_USER_PROFILE: {
      const { ...newState } = action.payload;
      return newState;
    }
    default:
      return state;
  }
};

export default userProfileReducer;
